// @ts-nocheck
import { request } from 'sonata-react-components';

import { ReportingTemplate, TabOptions } from '@/ts-modules/reporting/ReportDownload/types';

export async function getReportingTemplates(
  userId: string,
  token?: Record<string, any>
): Promise<{ amount: number; items: ReportingTemplate[] }> {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}report/template/${userId}`,
    {
      method: 'GET',
      params: {
        limit: 'unlimited',
        order: 'asc'
      }
    },
    token
  );
}

export async function deleteReportingTemplates(
  userId: string,
  templateId: string,
  token?: Record<string, any>
): Promise<void> {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}report/template/${userId}/${templateId}`,
    {
      method: 'DELETE'
    },
    token
  );
}

export async function addReportingTemplates(
  userId: string,
  templateName: string,
  templateType: string,
  templateTabsOptions: TabOptions[],
  token?: Record<string, any>
): Promise<void> {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}report/template/${userId}/undefined`,
    {
      data: {
        name: templateName,
        tabsOptions: templateTabsOptions,
        type: templateType,
        user: userId
      },
      method: 'POST'
    },
    token
  );
}
